// Returns the HTML for the form
export function CadastroFormPostal({ formId = "" } = {}) {
  const resolvedFormId = formId || "cadastro-form";
  return `
<section class="section bg-transparent py-8">
  <div class="container max-w-2xl mx-auto">
    <div class="bg-white/90 backdrop-blur-sm rounded-lg shadow-lg border border-white/30 p-4">

      <div class="mb-6 text-center">
        <h2 class="text-3xl font-bold text-gray-900 mb-4">
          ¡Comienza <span class="italic text-green-600">tu comparación gratuita ahora!</span>
        </h2>
        <p class="text-gray-600 mb-10">
          Elige entre profesionales verificados.
        </p>
      </div>

      <form class="space-y-6 text-left" id="${resolvedFormId}">


        <!-- Servicio -->
        <div class="flex gap-2 mb-6">
          <button type="button" data-service="certificado"
            class="flex-1 py-3 rounded-lg font-semibold text-white bg-green-500">
            Certificado energético
          </button>
          <button type="button" data-service="mejoras"
            class="flex-1 py-3 rounded-lg font-semibold bg-gray-300 text-gray-700">
            Informe de mejoras
          </button>
        </div>
        <input type="hidden" name="servicio" value="certificado" />

        

        <!-- Código registral button -->
<div class="relative w-full">
  <hr class="border-t border-gray-200 w-full" />

  <a
    href="/cadastro/"
    class="absolute right-0 -top-3 inline-block rounded-lg bg-gray-100 text-blue-600 text-base px-4 py-1 shadow-sm hover:bg-gray-200 transition"
  >
    Código registral
  </a>
</div>

        <!-- Tipo -->
        <div>
          <label class="block text-sm font-medium mb-1">¿Qué tipo de inmueble?</label>
          <select name="tipo"
            class="w-full rounded-lg border border-gray-300 px-4 py-3">
            <option value="">Seleccionar inmueble</option>
            <option>Piso</option>
            <option>Casa, chalet, unifamiliar</option>
            <option>Local</option>
            <option>Oficina individual</option>
            <option>Edificio</option>
          </select>
        </div>

        <!-- Superficie -->
        <div>
          <label class="block text-sm font-medium mb-1">
            ¿Qué superficie tiene el inmueble?
          </label>
          <select name="superficie"
            class="w-full rounded-lg border border-gray-300 px-4 py-3"
            disabled>
            <option value="">Selecciona un tamaño...</option>
          </select>
        </div>

        <!-- Código postal -->
        <div>
          <label class="block text-sm font-medium mb-1">
            Código postal del inmueble
          </label>
          <input
            id="postal-input"
            name="postal"
            type="text"
            class="w-full rounded-lg border border-gray-300 px-4 py-3"
            placeholder="Código postal"
            disabled
          />
          <p data-postal-error class="text-sm text-red-500 mt-1 hidden">
            Código postal no válido
          </p>
        </div>

        <!-- Hidden province -->
        <input type="hidden" name="province" id="province-input" />


        
        <button type="submit"
          class="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-4 rounded-lg disabled:bg-gray-300 disabled:text-gray-400 disabled:opacity-100 disabled:cursor-not-allowed">
          Compara precios ahora ›
        </button>

        <p class="text-sm text-green-600 text-center">
          en menos de 1 minuto y gratis
        </p>
      </form>
    </div>
  </div>
</section>



`;
}
// Call this after the form is inserted into the DOM
export function initCadastroFormPostalEvents(formId = "") {
  resetPostalSearchState();

  const isFormValid = () => {
    return (
      tipoSelect.value &&
      superficieSelect.value &&
      postalInput.value.length === 5 &&
      provinceInput.value
    );
  };
  // ─────────────────────────────
  // IDEMPOTENCY
  // ─────────────────────────────
  if (!window.__cadastroFormPostalInitialized) {
    window.__cadastroFormPostalInitialized = {};
  }
  const key = formId || "__default";
  if (window.__cadastroFormPostalInitialized[key]) return;
  window.__cadastroFormPostalInitialized[key] = true;

  // ─────────────────────────────
  // FORM
  // ─────────────────────────────
  const form = document.getElementById(formId || "cadastro-form");
  if (!form) return;

// ─────────────────────────────
// ELEMENTEN
// ─────────────────────────────
const tipoSelect = form.querySelector('[name="tipo"]');
const superficieSelect = form.querySelector('[name="superficie"]');
const postalInput = form.querySelector('[name="postal"]');
const provinceInput = form.querySelector('[name="province"]');
const errorEl = form.querySelector('[data-postal-error]');
const serviceButtons = form.querySelectorAll('[data-service]');
const serviceInput = form.querySelector('[name="servicio"]');


const handleInvalidPostal = () => {
  errorEl.classList.remove("hidden");
  postalInput.classList.add("border-red-500");
  postalInput.setAttribute("aria-invalid", "true");

  setTimeout(() => {
    window.location.href = "/cadastro/";
  }, 2000);
};

if (
  !tipoSelect ||
  !superficieSelect ||
  !postalInput ||
  !provinceInput ||
  !errorEl ||
  !serviceInput
) {
  console.warn("⚠️ CadastroFormPostal: ontbrekende form elementen", { formId });
  return;
}


  // ─────────────────────────────
  // FORM SUBMIT
  // ─────────────────────────────
  const submitBtn = form.querySelector('button[type="submit"]');

function handleSubmit(e) {
  e.preventDefault();

  if (!isFormValid()) {
    errorEl.classList.remove("hidden");
    postalInput.classList.add("border-red-500");
    postalInput.setAttribute("aria-invalid", "true");
    submitBtn.disabled = true;
    return;
  }

  const formData = Object.fromEntries(new FormData(form).entries());

  // ✅ BELANGRIJK: MERGE met bestaande storage
  const existing = JSON.parse(
    sessionStorage.getItem("propertySearchDataPost") || "{}"
  );

  const propertyData = {
    ...existing, // 👈 behoud municipios
    servicio: formData.servicio || "certificado",
    tipo: formData.tipo || "",
    superficie: formData.superficie || "",
    codigo_postal: postalInput.value || "",
    provincia: provinceInput.value || "",
    province: provinceInput.value || ""
  };

  sessionStorage.setItem(
    "propertySearchDataPost",
    JSON.stringify(propertyData)
  );

  setTimeout(() => {
    window.location.href = "/comparepost/";
  }, 150);
}


  form.addEventListener("submit", (e) => {
    handleSubmit(e);
  });

  // ─────────────────────────────
  // SERVICE BUTTONS
  // ─────────────────────────────
  serviceButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      serviceButtons.forEach((b) => {
        b.classList.remove("bg-green-500", "text-white");
        b.classList.add("bg-gray-300", "text-gray-700");
      });

      btn.classList.remove("bg-gray-300", "text-gray-700");
      btn.classList.add("bg-green-500", "text-white");
      serviceInput.value = btn.dataset.service || "";
    });
  });

  // ─────────────────────────────
  // SUPERFICIE CONFIG
  // ─────────────────────────────
  const optionsByTipo = {
    Piso: [
      "Menos de 50m2",
      "Entre 51 y 80m2",
      "Entre 81 y 120m2",
      "Entre 121 y 180m2",
      "Entre 181 y 350m2",
      "Entre 350 y 500m2",
      "Entre 501 y 1000m2",
    ],
    "Casa, chalet, unifamiliar": [
      "Menos de 80m2",
      "Entre 81 y 180m2",
      "Entre 181 y 240m2",
      "Entre 241 y 350m2",
      "Entre 351 y 500m2",
      "Entre 501 y 750m2",
      "Entre 751 y 1000m2",
    ],
    Local: [
      "Menos de 50m2",
      "Entre 51 y 80m2",
      "Entre 81 y 120m2",
      "Entre 121 y 180m2",
      "Entre 181 y 350m2",
      "Entre 350 y 500m2",
      "Entre 501 y 750m2",
    ],
    "Oficina individual": [
      "Menos de 50m2",
      "Entre 51 y 80m2",
      "Entre 81 y 120m2",
      "Entre 121 y 180m2",
      "Entre 181 y 350m2",
      "Entre 350 y 500m2",
      "Entre 501 y 1000m2",
    ],
    Edificio: [
      "Menos de 5 viviendas",
      "Entre 5 y 10 viviendas",
      "Entre 11 y 30 viviendas",
      "Entre 31 y 60 viviendas",
      "Entre 61 y 120 viviendas",
      "Entre 121 y 180 viviendas",
      "Entre 181 y 250 viviendas",
    ],
  };

const renderSuperficie = (tipo) => {
  const options = optionsByTipo[tipo] || [];
  superficieSelect.innerHTML = `
    <option value="">Selecciona un tamaño...</option>
    ${options.map(o => `<option value="${o}">${o}</option>`).join("")}
  `;
};

// ─────────────────────────────
// STATE LOGICA
// ─────────────────────────────
const updateState = () => {
  // Superficie actief zodra tipo is gekozen
  superficieSelect.disabled = !tipoSelect.value;

  // Postcode pas actief nadat gebruiker superficie kiest
  postalInput.disabled = !(tipoSelect.value && superficieSelect.value);

  // Submit opnieuw activeren bij geldige input
  const submitBtn = form.querySelector('button[type="submit"]');
  submitBtn.disabled = !isFormValid();
};

// ─────────────────────────────
// TIPO → SUPERFICIE
// ─────────────────────────────
tipoSelect.addEventListener("change", () => {
  renderSuperficie(tipoSelect.value);

  // GEEN automatische selectie
  superficieSelect.value = "";

  updateState();
});

// ─────────────────────────────
// SUPERFICIE → POSTCODE
// ─────────────────────────────
superficieSelect.addEventListener("change", updateState);

// ─────────────────────────────
// POSTCODE
// ─────────────────────────────

let lastCheckedPostal = "";

postalInput.addEventListener("input", async (e) => {
  const postal = e.target.value.replace(/\D/g, "").slice(0, 5);
  e.target.value = postal;

  errorEl.classList.add("hidden");
  postalInput.classList.remove("border-red-500");

  if (postal.length !== 5) {
    lastCheckedPostal = "";
    updateState();
    return;
  }

  if (postal === lastCheckedPostal) return;
  lastCheckedPostal = postal;

  postalInput.disabled = true;

  try {
    const res = await fetch(
      `/api/municipios/nombres?cp=${encodeURIComponent(postal)}`
    );
    if (!res.ok) throw new Error();

    const apiData = await res.json();

    if (!apiData.provincia) {
      throw new Error("Invalid postal");
    }

    provinceInput.value = apiData.provincia;

    // ✅ MERGE in sessionStorage (BEHOUDT alles)
    const stored = JSON.parse(
      sessionStorage.getItem("propertySearchDataPost") || "{}"
    );

    stored.codigo_postal = postal;
    stored.provincia = apiData.provincia;
    stored.province = apiData.provincia;

    // Zonas (werkgebied)
    stored.municipios = Array.isArray(apiData.municipios)
      ? [...new Set(apiData.municipios.map(m => m.trim()))]
          .sort((a, b) => a.localeCompare(b, "es"))
      : [];

    sessionStorage.setItem(
      "propertySearchDataPost",
      JSON.stringify(stored)
    );

    updateState();

  } catch {
    errorEl.classList.remove("hidden");
    postalInput.classList.add("border-red-500");
    postalInput.setAttribute("aria-invalid", "true");
    lastCheckedPostal = "";
  } finally {
    postalInput.disabled = false;
  }
});

function resetPostalSearchState() {
  // Alleen search/result context resetten
  sessionStorage.removeItem("propertyData");
  sessionStorage.removeItem("searchType");



  // Geselecteerde adviseur / booking
  localStorage.removeItem("selectedPartner");
  localStorage.removeItem("selectedAdvisorData");
  localStorage.removeItem("bookingPropertyData");
}

// ─────────────────────────────
// INIT
// ─────────────────────────────
resetPostalSearchState();
updateState();
}

